<template>
  <li v-show="node.visible" :class="{'tree__node--open': childNodeRendered && expanded,'tree__node-leaf': node.isLeaf}" class="tree__node">
    <div :class="{
      'tree__node-content--checked': isSelect && node.selected,
      'd-inline-block' : node.store.horizontalScroll
    }" class="tree__node-content" @click="onClick">
      <div :style="indentStyle" :class="{
        'tree__node--open': childNodeRendered && expanded,
        'tree__node-leaf': node.isLeaf,
        'd-inline-block' : node.store.horizontalScroll
      }" class="tree__node-title text-nowrap">
        <node-content :node="node" :style="contentStyle" :class="{
          'text-truncate': !node.store.horizontalScroll,
          'text-nowrap': node.store.horizontalScroll,
          'd-inline-block' : node.store.horizontalScroll,
          'w-100' : !node.store.horizontalScroll,
        }" class="float-right"></node-content>
        <i v-show="!node.loading" class="tree__node-title--toggle" @click.stop="$_onExpandIconClick"></i>
        <i v-show="node.loading" :class="`${$constants.PREFIX_ICON_CLASS}ani-loop aid ${$constants.PREFIX_ICON_CLASS}loading`" style="width: 1rem;"></i>
        <t-checkbox v-if="isCheck" v-model="node.checked" :disabled="!!node.disabled" :indeterminate="node.indeterminate" label="" @on-change="onCheckChange">
        </t-checkbox>
      </div>
    </div>
    <ul v-show="expanded" class="tree__child-tree">
      <t-tree-node v-for="(child, index) in node.childNodes" :render-content="renderContent" :key="index" :node="child" @node-expand="onChildNodeExpand">
      </t-tree-node>
    </ul>
  </li>
</template>

<script type="text/jsx">
import TCheckbox from '../checkbox/checkbox.vue'
import Emitter from '../../mixins/emitter'

export default {
  name: 'TTreeNode',
  components: {
    TCheckbox,
    NodeContent: {
      props: {
        node: {
          required: true
        }
      },
      render: function(createElement) {
        const parent = this.$parent
        const node = this.node
        const data = node.data
        const store = node.store
        return parent.renderContent
          ? createElement(
            'span',
            {
              class: {
                'tree__node-text': true
              }
            },
            [
              parent.renderContent.call(parent._renderProxy, createElement, {
                _self: parent.tree.$vnode.context,
                node,
                data,
                store
              })
            ]
          )
          : createElement(
            'span',
            {
              attrs: {
                title: this.node.data.title || this.node.label
              },
              class: {
                'tree__node-text': true
              }
            },
            this.node.label
          )
      }
    }
  },
  mixins: [Emitter],
  props: {
    node: {
      type: Object,
      default() {
        return {}
      }
    },
    props: {
      type: Object
    },
    renderContent: Function
  },
  data() {
    return {
      tree: null,
      expanded: false,
      childNodeRendered: false,
      isCheck: false,
      isSelect: true,
      selected: false,
      oldChecked: null,
      oldIndeterminate: null
    }
  },
  computed: {
    indentStyle() {
      // let leafLeft = this.node.isLeaf ? 16 : 0
      let style = {}
      style.paddingLeft = `${16 * this.node.level}px`
      return style
    },
    contentStyle() {
      let style = {}
      if (this.node.loading) {
        style.paddingLeft = `12px`
      }
      if (this.isCheck) {
        style.paddingLeft = '45px'
      } else {
        style.paddingLeft = '18px'
      }
      if (this.node.store.horizontalScroll) {
        style.minWidth = '100%'
      }
      return style
    }
  },
  watch: {
    'node.indeterminate'(val) {
      this.$_onSelectChange(this.node.checked, val)
    },
    'node.checked'(val) {
      this.$_onSelectChange(val, this.node.indeterminate)
    },
    'node.expanded'(val) {
      this.expanded = val
      if (val) {
        this.childNodeRendered = true
      }
    }
  },
  created() {
    const parent = this.$parent

    if (parent.isTree) {
      this.tree = parent
    } else {
      this.tree = parent.tree
    }

    const tree = this.tree
    if (!tree) {
      console.warn("Can not find node's tree.")
    }

    const props = tree.props || {}
    const childrenKey = props['children'] || 'children'

    this.$watch(`node.data.${childrenKey}`, () => {
      this.node.updateChildren()
    })

    this.isCheck = tree.isCheck
    this.isSelect = tree.isSelect

    if (this.node.expanded) {
      this.expanded = true
      this.childNodeRendered = true
    }

    if (this.tree.accordion) {
      this.$on('node-expand', (props, node) => {
        node.parent.childNodes.forEach(i => {
          if (node.id !== i.id) {
            i.collapse()
          }
        })
      })
    }
  },
  methods: {
    // 添加私有方法
    $_onSelectChange(checked, indeterminate) {
      if (
        this.oldChecked !== checked &&
        this.oldIndeterminate !== indeterminate
      ) {
        this.tree.$emit(
          'checked-change',
          this.node.data,
          checked,
          indeterminate
        )
      }
      this.oldChecked = checked
      this.indeterminate = indeterminate
    },
    onClick(e) {
      const store = this.tree.store
      store.setCurrentNode(this.node)
      this.tree.$emit(
        'current-change',
        store.currentNode ? store.currentNode.data : null,
        store.currentNode
      )
      this.tree.currentNode = this
      if (this.tree.expandOnClickNode) {
        this.$_onExpandIconClick()
      }
      if (this.isSelect && e.target.className.indexOf('checkbox') <= -1) {
        this.node.setSelected(!this.node.selected)
        this.tree.$emit('on-select', this.node.data, this.node, this)
      }
      this.tree.$emit('on-click', this.node.data, this.node, this)
    },
    $_onExpandIconClick() {
      if (this.node.isLeaf) return
      if (this.expanded) {
        this.tree.$emit('node-collapse', this.node.data, this.node, this)
        this.node.collapse()
      } else {
        this.node.expand()
        this.$emit('node-expand', this.node.data, this.node, this)
      }
    },
    onCheckChange(checked) {
      this.node.setChecked(checked, !this.tree.checkStrictly)
    },
    onChildNodeExpand(nodeData, node, instance) {
      this.broadcast('t-tree-node', 'node-expand', node)
      this.tree.$emit('node-expand', nodeData, node, instance)
    }
  }
}
</script>



// WEBPACK FOOTER //
// tree-node.vue?1eb8e2a8